import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:id',
    name: 'default',
    component: () => import('@/views/Bot.vue'),
  },
  {
    path: '/error',
    name: 'error-default',
    component: () => import('@/views/Error/Default.vue'),
    props: route => ({
      error: route.params.error,
    }),
  },
  { path: '*', name: 'error-404', component: () => import('@/views/Error/404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/') {
    const routeNewId = 'b3SSqKRmFMIjX8abLFpXsfXqAo9Nqu3z'
    if (routeNewId) {
      router.push({ name: 'default', params: { id: routeNewId } })
    }
  }
  next()
})

export default router
